import styled from "styled-components";

export type EmojiStyleProps = {
    size: string | number
    offset?: string
}

export const StyledEmoji = styled.img<EmojiStyleProps> `
    image-rendering: -webkit-optimize-contrast;
    height: ${props => typeof props.size == "number" ? `${props.size}px` : props.size};
    min-width: ${props => typeof props.size == "number" ? `${props.size}px` : props.size};
    vertical-align: middle;
    transform: translateY(${props => `-${props.offset}`});
`;
